__turbopack_context__.v({
  "className": "opendyslexic_2852716e-module__Jc7WMq__className",
});
